import axios from "axios";
import { useState, useEffect } from "react";
import { generateAuthToken } from "../../services/api";
import TokenContext from "../tokenContext";

export const TokenProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [validToken, setValidToken] = useState(false);

  useEffect(() => {
    const fetchToken = async () => {
      setIsLoading(true);
      await generateAuthToken().then((response) => {
        if (response?.status === 200 || response?.status === 201) {
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.access_token}`;
          setValidToken(true);
        }
      });
      setIsLoading(false);
    };
    fetchToken();
  }, []);

  return (
    <TokenContext.Provider value={{ isLoading, validToken }}>
      {children}
    </TokenContext.Provider>
  );
};
